<template>
  <div class="main">
    <Header :title="title" />
    <div class="container my-con">
      <div class="card">
        <van-row class="institution">
          <van-col span="16">
            <div style="display: inline-block; width: 0.56rem; height: 0.56rem">
              <img
                v-if="reportInfo.logo"
                :src="reportInfo.logo"
                alt="logo"
                width="100%"
                style="vertical-align: middle"
              />
              <img
                v-else
                src="../assets/img/ins_logo.png"
                alt="logo"
                width="100%"
                style="vertical-align: middle"
              />
            </div>
            <span>{{ reportInfo.institutionName }}</span>
          </van-col>
          <van-col span="8" style="text-align: end">
            {{ reportInfo.createDate }}
          </van-col>
        </van-row>
        <h2 class="title">宫颈筛查报告</h2>
        <baseInfo
          :base-info="reportInfo"
          :location="'overview'"
          style="padding-bottom: 10px"
        />
      </div>
      <!-- 妇科 -->
      <div class="card">
        <div
          v-if="
            reportInfo.cervixRes &&
            reportInfo.cervixRes !== '待查' &&
            reportInfo.cervixRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('gynecologyReport')"
        >
          <div class="title">妇科检查</div>
          <div class="content">
            {{ reportInfo.cervixRes }}
          </div>
          <div class="gynecologyReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 乳腺触诊 -->
      <div v-if="reportInfo.doBreastWhenCervix === 1" class="card">
        <div
          v-if="
            reportInfo.breastRes &&
            reportInfo.breastRes !== '待查' &&
            reportInfo.breastRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('palpationReport')"
        >
          <div class="title">触诊检查</div>
          <div class="content">
            {{ reportInfo.breastRes }}
          </div>
          <div class="palpationReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- HPV -->
      <div class="card">
        <div
          v-if="
            reportInfo.hpvRes &&
            reportInfo.hpvRes !== '待查' &&
            reportInfo.hpvRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('HPVReport')"
        >
          <div class="title">HPV检查</div>
          <div class="content">
            {{ reportInfo.hpvRes }}
          </div>
          <div class="HPVReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 细胞学 -->
      <div class="card">
        <div
          v-if="
            reportInfo.cytologyRes &&
            reportInfo.cytologyRes !== '待查' &&
            reportInfo.cytologyRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('cellReport')"
        >
          <div class="title">细胞学检查</div>
          <div class="content">
            {{ reportInfo.cytologyRes }}
          </div>
          <div class="cellReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- VIA/VILI -->
      <div class="card">
        <div
          v-if="
            reportInfo.viaViliRes &&
            reportInfo.viaViliRes !== '待查' &&
            reportInfo.viaViliRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('VIAReport')"
        >
          <div class="title">VIA/VILI检查</div>
          <div class="content">
            {{ reportInfo.viaViliRes }}
          </div>
          <div class="VIAReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 阴道镜 -->
      <div class="card">
        <div
          v-if="
            reportInfo.colposcopeRes &&
            reportInfo.colposcopeRes !== '待查' &&
            reportInfo.colposcopeRes !== '无需检查' && isColposcope
          "
          class="resultBox"
          @click="handleSkip('colposcopeReport')"
        >
          <div class="title">阴道镜检查</div>
          <div class="content">
            {{ reportInfo.colposcopeRes }}
          </div>
          <div class="colposcopeReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 病理 -->
      <div class="card">
        <div
          v-if="
            reportInfo.pathologicalCervixRes &&
            reportInfo.pathologicalCervixRes !== '待查' &&
            reportInfo.pathologicalCervixRes !== '无需检查' && isPathological
          "
          class="resultBox"
          @click="handleSkip('pathologyReport')"
        >
          <div class="title">病理检查</div>
          <div class="content">
            {{ pathologicalCervixRes }}
          </div>
          <div class="pathologyReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button type="info" class="btn">
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <van-cell
          title="上传资料"
          class="upload-data"
          is-link
          @click="viewUserData"
        />
      </div>
      <div class="card">
        <van-cell
          title="知情同意书"
          class="upload-data"
          is-link
          @click="viewAgreement"
        />
      </div>
      <div class="card">
        <van-cell
          title="推荐医生"
          class="upload-data"
          is-link
          @click="recommendDoctor"
        />
        <div class="tj_doctor_list" @touch.stop>
          <div
            class="tj_doctor_item"
            v-for="(item, index) in this.recommendDocs"
            :key="index"
          >
            <van-image
              :src="$imgUrl + item.headicon"
              type="fill"
              :error-icon="require('../assets/img/doctor_img.png')"
              error-class="error-img"
            />
            <p>
              <span class="name">{{ item.name }}</span>
              <span class="ks">{{ item.department }}</span>
            </p>
            <p class="hospital">
              {{ item.hospital }}
            </p>
            <van-button
              size="small"
              round
              icon="phone-o"
              text="联系医生"
              @click.stop="phone(item.phone)"
            />
          </div>
        </div>
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
          <div class="block" @click.stop>
            <p>{{ phoneNumber }}</p>
            <div class="footer">
              <span class="cancel" @click="show = false">取消</span>
              <a :href="'tel:' + phoneNumber">
                <span class="confirm"> 拨打 </span>
              </a>
            </div>
          </div>
        </div>
      </van-overlay>
      <van-overlay :show="loading">
        <div class="loading-box">
          <van-loading>加载中...</van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Header from "../components/header";
import baseInfo from "@/components/baseInfo";
import {
  Row,
  Col,
  Divider,
  Icon,
  Image,
  Cell,
  CollapseItem,
  Overlay,
  Button,
  Loading,
} from "vant";
import moment from "moment";
import { deepJsonParse } from "@/utils/handleJSON";
import { formatPathologicalCervixResult } from "@/utils/pathologicalCervix";

export default {
  components: {
    Header,
    baseInfo,
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
  },
  data() {
    return {
      title: "宫颈筛查报告",
      reportInfo: {
        id: "",
        name: "",
        sex: "",
        age: "",
        institutionName: "",
        logo: "",
        createDate: "",
      },
      recommendDocs: [],
      phoneNumber: "",
      show: false,
      loading: false,
    };
  },
  computed: {
    pathologicalCervixRes() {
      return formatPathologicalCervixResult(
        this.reportInfo.pathologicalCervix,
        this.reportInfo.fertileCheck,
        this.reportInfo.pathologicalCervixRes
      );
    },
    isPathological() {
      let str = true
      const Json = this.reportInfo.pathologicalCervix || {}
      if (Json.jieshoubinglijiancha == '否') {
        str = false
      }
      return str
    },
    isColposcope() {
      let str = true
      const Json = this.reportInfo.colposcope || {}
      if (Json.shifoujieshouyindaojing == '否') {
        str = false
      }
      return str
    }
  },
  created() {
    this.getData();
    this.getRecommendDoctorList();
  },
  methods: {
    async getData() {
      this.loading = true;
      // 获取报告详情
      const { data } = await this.$api.personal.getReportDetail({
        id: this.$route.params.id,
      });
      // 获取机构详情 -》 获取筛查机构logo
      const { data: ins } = await this.$api.personal.getInstitutionById({
        id: data.institutionId,
      });
      this.loading = false;
      // 对数据进行深度解析
      const { createDate, ...detail } = deepJsonParse(JSON.stringify(data));
      detail.createDate = createDate && moment(createDate).format("YYYY.MM.DD");
      detail.logo = ins.logoUrl ? this.$imgUrl + ins.logoUrl : "";
      // 宫颈检查是否同时做乳腺（读取机构配置） -> 1是 2否
      detail.doBreastWhenCervix = ins.doBreastWhenCervix;
      detail.fertileCheck = ins.fertileCheck;
      this.reportInfo = detail;
    },
    // 获取医生推荐列表
    async getRecommendDoctorList() {
      const { data } = await this.$api.personal.getDoctorList({
        villageCode: 0,
        page: 1,
        limit: 10,
      });
      this.recommendDocs = data;
    },
    handleSkip(path) {
      if (path === "palpationReport") {
        this.$router.push({
          path: `/breast/${path}/${this.reportInfo.id}`,
        });
      } else {
        this.$router.push({
          path: `/cervical/${path}/${this.reportInfo.id}`,
        });
      }
    },
    viewUserData() {
      this.$router.push(`/jcbg/${this.reportInfo.id}`);
    },
    viewAgreement() {
      this.$router.push(`/viewAgreement/${this.$route.params.id}`);
    },
    recommendDoctor() {
      this.$router.push("/doctorList");
    },
    phone(phone) {
      this.phoneNumber = phone;
      this.show = true;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  font-size: 0.32rem;
  background-color: #f7f7f7;
  ::v-deep {
    .van-icon__image {
      width: 100%;
      height: 100%;
    }
  }
  .card {
    background-color: white;
    margin-bottom: 0.2rem;
  }
  .institution {
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    padding: 0.3rem;
  }

  h2 {
    font-size: 0.44rem;
    font-weight: 400;
    text-align: center;
    padding-bottom: 15px;
  }
}
.resultBox {
  padding: 0.2rem 0.3rem;
  font-size: 0.28rem;
  position: relative;
  .title {
    font-size: 0.3rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .content {
    position: relative;
    color: #999999;
    z-index: 1;
    width: 90%;
  }
  .arrow {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -15px;
  }
  .gynecologyReport,
  .HPVReport,
  .cellReport,
  .VIAReport,
  .colposcopeReport,
  .pathologyReport {
    position: absolute;
    right: 25vw;
    bottom: 0;
    width: 70px;
    height: 70px;
    background-image: url("../assets/img/breast_repo_bg_img.png");
    background-position: 1027px 77px;
  }
  .HPVReport {
    background-position: 947px 77px;
  }
  .cellReport {
    background-position: 874px 77px;
  }
  .VIAReport {
    background-position: 797px 77px;
  }
  .colposcopeReport {
    background-position: 727px 77px;
  }
  .pathologyReport {
    background-position: 587px 77px;
  }
}
.upload-data {
  font-size: 0.28rem;
}
.tj_doctor_list {
  background: #fff;
  padding-top: 24px;
  padding-bottom: 11px;
  display: flex;
  margin-bottom: 10px;
  overflow-x: scroll;
  border-top: 1px solid #f5f5f5;
  .tj_doctor_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0 28px;
    width: 100px;
    &::after {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      content: "";
      width: 1px;
      height: 162px;
      background: #eeeeee;
    }
    .van-image {
      width: 90px;
      height: 90px;
      border-radius: 45px;
      overflow: hidden;
      margin-bottom: 12px;
    }
    p {
      width: 100%;
      font-size: 14px;
      color: #333;
      line-height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      text-align: center;
      .name {
        font-weight: 600;
        color: #444;
        margin-right: 6px;
      }
      &.hospital {
        font-size: 12px;
        margin: 6px 0 12px;
      }
    }
    .van-button {
      width: 100px;
      height: 30px;
      background: rgba(78, 124, 254, 1);
      box-shadow: 0 3px 8px 0 rgba(78, 124, 254, 0.4);
      border-radius: 15px;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
      border: none;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 5rem;
  height: 2.12rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.06rem 0.18rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.1rem;
  font-size: 0.36rem;
  line-height: 0.5rem;
  p {
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-top: 0.45rem;
    text-align: center;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.2rem;
      height: 0.6rem;
      border-radius: 0.3rem;
    }
    .cancel {
      color: #333;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0.06rem 0.16rem 0 rgba(184, 184, 184, 0.4);
      margin-right: 25px;
    }
    .confirm {
      color: #fff;
      background: rgba(78, 124, 254, 1);
      box-shadow: 0 0.06rem 0.16rem 0 rgba(78, 124, 254, 0.4);
    }
  }
}

.share-report1 {
  font-size: 0.2rem;
  .link {
    color: rgba(78, 124, 254, 1);
  }
  .btn-box {
    margin-top: 0.2rem;
    display: flex;
    justify-content: center;
  }
  .btn {
    width: 86%;
  }
}
.loading-box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-loading__text {
    color: #ffffff;
  }
  .van-loading {
    color: #ffffff;
  }
}
</style>
